module.exports = __webpack_public_path__ + "img/p21.0787a093.svg";